module.exports = __webpack_public_path__ + "static/media/1-3-4.348ee2f7.png";